/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Toast_Status_UpdatedInputs */

const vi_vehicle_toast_status_updated = /** @type {(inputs: Vehicle_Toast_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã cập nhật trạng thái xe`)
};

/**

* @param {Vehicle_Toast_Status_UpdatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_toast_status_updated = /** @type {((inputs?: Vehicle_Toast_Status_UpdatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Toast_Status_UpdatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_toast_status_updated(inputs)
});